// import PropTypes from "prop-types"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Row, Input, Form, FormFeedback, Button, Spinner, Table } from "reactstrap";
import { Label, InputGroup, Card, CardBody, Tooltip } from "reactstrap";
import * as Yup from "yup";
import { useFormik, FieldArray, FormikProvider } from "formik";
import fn_helper from "helpers/fn_helper";
import PopupAttachment from "components/Input/attachment/PopupAttachment";

const LinkOut = ({
    validation,
    pageView
}) => {
    return(
        <>
            <Col className="col-12 mb-3">
                <label
                    htmlFor="contentPageName"
                    className="col-md-12 col-form-label"
                >
                    Page Name
                    <span className="t-require">*</span>
                </label>
                <div className="col-md-12">
                    <Input
                        id="contentPageName"
                        className="form-control"
                        type="text"
                        placeholder=""
                        name="contentPageName"
                        onChange={e => {
                            validation.setFieldValue(
                                "contentPageName",
                                e.target.value
                            )
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.contentPageName}
                        invalid={
                            validation.touched.contentPageName &&
                                validation.errors.contentPageName
                                ? true
                                : false
                        }
                        disabled={pageView === "view"}
                    />
                    {validation.touched.contentPageName &&
                        validation.errors.contentPageName && (
                            <FormFeedback type="invalid">
                                {validation.errors.contentPageName}
                            </FormFeedback>
                        )}
                </div>
                <hr />
            </Col>
            <Col className="col-12 mb-3">
                <label
                    htmlFor="contentLinkout"
                    className="col-md-12 col-form-label"
                >
                    Link Out
                    <span className="t-require">*</span>
                </label>
                <div className="col-md-12">
                    <Input
                        id="contentLinkout"
                        className="form-control"
                        type="text"
                        placeholder=""
                        name="contentLinkout"
                        onChange={e => {
                            validation.setFieldValue(
                                "contentLinkout",
                                e.target.value
                            )
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.contentLinkout}
                        invalid={
                            validation.touched.contentLinkout &&
                                validation.errors.contentLinkout
                                ? true
                                : false
                        }
                        disabled={pageView === "view"}
                    />
                    {validation.touched.contentLinkout &&
                        validation.errors.contentLinkout && (
                            <FormFeedback type="invalid">
                                {validation.errors.contentLinkout}
                            </FormFeedback>
                        )}
                </div>
                <hr />
            </Col>
        </>
    )
}
export default LinkOut